import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { Country, State } from "country-state-city";
import userApiProvider from "../apiProvider/userApi";
import chapterApiProvider from "../apiProvider/chapterApi";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/auth";
import Select from "react-select";
import { Tag, Tooltip } from "antd";
import debounce from "lodash.debounce";
const ChapterAccessLayer = () => {
  // Zone Modal State
  const [zoneFormData, setZoneFormData] = useState({
    countryName: "",
    stateName: "",
    zoneName: "",
    dob: "",
  });

  // Chapter Modal State
  const [chapterFormData, setChapterFormData] = useState({
    chapterName: "",
    countryName: "",
    stateName: "",
    zoneId: "",
    cidId: [],
    mentorId: "",
    meetingVenue: "",
    chapterCreatedDate: "",
    meetingDayAndTime: "",
    meetingType: "In Person",
  });

  // Selected Chapter for Edit
  const [selectedChapter, setSelectedChapter] = useState(null);

  // Data Options
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [zones, setZones] = useState([]);
  const [cids, setCids] = useState([]);
  const [mentors, setMentors] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [chapters, setChapters] = useState([]);
  const [options, setOptions] = useState([
    { value: "Chennai", label: "Chennai" },
  ]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [errors, setErrors] = useState({});
  const [chaptererror, setChapterError] = useState({});
  // Fetch initial data
  useEffect(() => {
    fetchCountries();
    fetchChapters();
    fetchCIds({ role: "CID" });
    fetchMentors({ role: "mentor" });
  }, []);

  const fetchCountries = () => {
    const countryData = Country.getAllCountries().map((country) => ({
      value: country.isoCode,
      label: country.name,
    }));
    setCountries(countryData);
  };

  const fetchStates = (countryCode) => {
    const stateData = State.getStatesOfCountry(countryCode).map((state) => ({
      value: state.isoCode,
      label: state.name,
    }));
    setStates(stateData);
  };


  const fetchZonesByState = async (countryName, stateName) => {
    const response = await chapterApiProvider.getZonesByState(stateName);
    if (response && response.status) {
      const zoneOptions = response.response.data.map((zone) => ({
        value: zone._id,
        label: zone.zoneName,
      }));
      setZones(zoneOptions);
    }
  };


  const fetchCIds = async () => {
    const response = await userApiProvider.getUsersByRole({ role: "CID" });
    if (response && response.status) {
      const cidOptions = response.response.data.map((user) => ({
        value: user._id,
        label: user.name,
      }));
      setCids(cidOptions);
    }
  };
  const fetchMentors = async () => {
    const response = await userApiProvider.getUsersByRole({ role: "mentor" });
    if (response && response.status) {
      const mentorOptions = response.response.data.map((user) => ({
        value: user._id,
        label: user.name,
      }));
      setMentors(mentorOptions);
    }
  };
  const debouncedFetchChapters = React.useCallback(
    debounce((query) => {
      fetchChapters(query);
    }, 500),
    []
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedFetchChapters(value);
  };
  const fetchChapters = async (search = "") => {
    try {
      const response = await chapterApiProvider.getAllChapters({ search });
      if (response && response.status) {
        setChapters(response.response.data);
      }
    } catch (error) {
      console.error("Error fetching chapters:", error);
      // Handle the error (e.g., show error message to user)
    }
  };

  // Zone Form Handlers (keep existing)
  const handleZoneCountryChange = (e) => {
    const countryName = e.target.value;
    setZoneFormData({ ...zoneFormData, countryName, stateName: "" });
    fetchStates(countryName);
  };

  const handleZoneStateChange = (e) => {
    const stateName = e.target.value;
    setZoneFormData({ ...zoneFormData, stateName });
  };

  const handleZoneInputChange = (e) => {
    const { name, value } = e.target;
    setZoneFormData({ ...zoneFormData, [name]: value });
  };

  const handleZoneSubmit = async (e) => {
    const newErrors = {};
    e.preventDefault();
    if (!zoneFormData.zoneName || zoneFormData.zoneName.trim() === "") {
      newErrors.zoneName = "Zone name is required";
      setErrors(newErrors);
      return false;
    }
    // else if (!/^[A-Za-z\s]+$/.test(zoneFormData.zoneName)) {
    //   newErrors.zoneName = 'Only alphabets and spaces allowed';
    //   setErrors(newErrors);
    //   return false
    // }

    // Country validation
    if (!zoneFormData.countryName) {
      newErrors.countryName = "Country is required";
      setErrors(newErrors);
      return false;
    }

    // State validation
    if (!zoneFormData.stateName) {
      newErrors.stateName = "State is required";
      setErrors(newErrors);
      return false;
    }

    // Date of Birth validation
    if (!zoneFormData.dob) {
      newErrors.dob = "Date of birth is required";
      setErrors(newErrors);
      return false;
    } else {
      const dobDate = new Date(zoneFormData.dob);
      const today = new Date();
      if (dobDate > today) {
        newErrors.dob = "Date cannot be in the future";
        setErrors(newErrors);
        return false;
      }
    }

    // Zone Head validation
    if (!zoneFormData.zoneHead.length) {
      newErrors.zoneHead = "Zone head is required";
      setErrors(newErrors);
      return false;
    }

    try {
      const response = await chapterApiProvider.createZone(zoneFormData);
      if (response && response.status) {
        Swal.fire({
          title: "Success!",
          text: "Zone created successfully",
          icon: "success",
          customClass: {
            popup: "small-swal-popup",
            title: "small-swal-title",
            htmlContainer: "small-swal-text",
          },
          width: "400px",
        });
        document.getElementById("closeZoneModal").click();
        setZoneFormData({
          countryName: "",
          stateName: "",
          zoneName: "",
          dob: "",
          zoneHead: [],
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to create zone",
        icon: "error",
        customClass: {
          popup: "small-swal-popup",
          title: "small-swal-title",
          htmlContainer: "small-swal-text",
        },
        width: "400px",
      });
    }
  };

  // Chapter Form Handlers
  const handleChapterCountryChange = (e) => {
    const countryName = e.target.value;
    setChapterFormData({
      ...chapterFormData,
      countryName,
      stateName: "",
      zoneId: "",
    });
    fetchStates(countryName);
  };

  const handleChapterStateChange = (e) => {
    const stateName = e.target.value;
    setChapterFormData({ ...chapterFormData, stateName, zoneId: "" });
    fetchZonesByState(chapterFormData.countryName, stateName);
  };

  const handleChapterZoneChange = (e) => {
    const zoneId = e.target.value;
    setChapterFormData((prev) => ({
      ...prev,
      zoneId,
    }));
  };

  const handleChapterInputChange = (e) => {
    setErrors({});
    const { name, value } = e.target;
    setChapterFormData({ ...chapterFormData, [name]: value });
  };

  const handleChapterSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (
      !chapterFormData.chapterName ||
      chapterFormData.chapterName.trim() === ""
    ) {
      newErrors.chapterName = "Chapter name is required";
      setChapterError(newErrors);
      return false;
    }
    // else if (!/^[A-Za-z\s]+$/.test(chapterFormData.chapterName)) {
    //   newErrors.chapterName = 'Only alphabets and spaces allowed';
    //   setChapterError(newErrors);
    //   return false
    // }

    // Country validation
    if (!chapterFormData.countryName) {
      newErrors.countryName = "Country is required";
      setChapterError(newErrors);
      return false;
    }

    // State validation
    if (!chapterFormData.stateName) {
      newErrors.stateName = "State is required";
      setChapterError(newErrors);
      return false;
    }

    // Zone validation
    if (!chapterFormData.zoneId) {
      newErrors.zoneId = "Zone is required";
      setChapterError(newErrors);
      return false;
    }

    // CID validation
    if (!chapterFormData.cidId.length) {
      newErrors.cidId = "CID is required";
      setChapterError(newErrors);
      return false;
    }

    // Location validation
    if (
      !chapterFormData.meetingVenue ||
      chapterFormData.meetingVenue.trim() === ""
    ) {
      newErrors.meetingVenue = "Meeting venue is required";
      setChapterError(newErrors);
      return false;
    }
    //  else if (!/^[A-Za-z\s]+$/.test(chapterFormData.meetingVenue)) {
    //   newErrors.meetingVenue = 'Only alphabets and spaces allowed';
    //   setChapterError(newErrors);
    //   return false
    // }

    // Chapter Created Date validation
    if (!chapterFormData.chapterCreatedDate) {
      newErrors.chapterCreatedDate = "Chapter created date is required";
      setChapterError(newErrors);
      return false;
    } else {
      const createdDate = new Date(chapterFormData.chapterCreatedDate);
      const today = new Date();
      if (createdDate > today) {
        newErrors.chapterCreatedDate = "Date cannot be in the future";
        setChapterError(newErrors);
        return false;
      }
    }

    // Meeting Day & Time validation
    if (!chapterFormData.meetingDayAndTime) {
      newErrors.meetingDayAndTime = "Meeting day and time is required";
      setChapterError(newErrors);
      return false;
    }

    // Meeting Type validation
    if (!chapterFormData.meetingType) {
      newErrors.meetingType = "Meeting type is required";
      setChapterError(newErrors);
      return false;
    }

    try {
      const response = await chapterApiProvider.createChapter(chapterFormData);
      if (response && response.status) {
        Swal.fire({
          title: "Success!",
          text: "Chapter created successfully",
          icon: "success",
          customClass: {
            popup: "small-swal-popup",
            title: "small-swal-title",
            htmlContainer: "small-swal-text",
          },
          width: "400px",
        });
        document.getElementById("closeChapterModal").click();
        setChapterFormData({
          chapterName: "",
          countryName: "",
          stateName: "",
          zoneId: "",
          cidId: [],
          meetingVenue: "",
          chapterCreatedDate: "",
          meetingDayAndTime: "",
          meetingType: "In Person",
        });
        fetchChapters();
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to create chapter",
        icon: "error",
        customClass: {
          popup: "small-swal-popup",
          title: "small-swal-title",
          htmlContainer: "small-swal-text",
        },
        width: "400px",
      });
    }
  };

  // Creatable Select Handlers
  const handleChange = (newValue) => {
    setErrors({});
    setSelectedOption(newValue);
    setZoneFormData({ ...zoneFormData, zoneName: newValue.value });
  };

  const handleCreate = (inputValue) => {
    setErrors({});
    const newOption = { value: inputValue, label: inputValue };
    setOptions((prev) => [...prev, newOption]);
    setSelectedOption(newOption);
    setZoneFormData({ ...zoneFormData, zoneName: inputValue });
  };
  function formatDayName(dateString) {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const date = new Date(dateString);
    return days[date.getDay()];
  }
  // console.log(chapterFormData,"chapterFormDatachapterFormData");

  return (
    <>
      <div className="card-header mb-3 border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <form className="navbar-search">
            <input
              type="text"
              className="bg-base h-40-px w-auto"
              name="search"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <Icon icon="ion:search-outline" className="icon" />
          </form>
        </div>

        <div className="d-flex align-items-center flex-wrap gap-1">
          {hasPermission("chapters-create") && (
            <button
              type="button"
              className="btn btn-primary grip text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
              data-bs-toggle="modal"
              data-bs-target="#exampleModalTwo"
            >
              <Icon
                icon="ic:baseline-plus"
                className="icon text-xl line-height-1"
              />
              Add Zone
            </button>
          )}
          {hasPermission("chapters-create") && (
            <button
              type="button"
              className="btn btn-primary grip text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              <Icon
                icon="ic:baseline-plus"
                className="icon text-xl line-height-1"
              />
              Add New
            </button>
          )}
        </div>
      </div>

      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="row gy-4">
            {chapters.map((chapter) => (
              <div
                className="col-12 col-xxl-4 col-lg-4 col-sm-6 mb-0"
                key={chapter._id}
              >
                <div className="folded">
                  <h2>{chapter.chapterName}</h2>
                </div>

                <div
                  className="kanban-card bg-neutral-50 p-3 radius-8"
                  style={{ userSelect: "none", background: "#fff" }}
                >
                  <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ padding: "8px 0" }}>
                          <strong>Chapter day:</strong>
                        </td>
                        <td style={{ padding: "8px 0" }}>
                          {formatDayName(chapter.meetingDayAndTime)}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "8px 0" }}>
                          <strong>Zone:</strong>
                        </td>
                        <td style={{ padding: "8px 0" }}>
                          {chapter.zoneId?.zoneName || "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ padding: "8px 0" }}>
                          <strong>CID:</strong>
                        </td>
                        <td style={{ padding: "8px 0" }}>
                          {chapter.cidId?.length > 0 ? (
                            <>
                              <Tag color="#c02222">{chapter.cidId[0]?.name}</Tag>

                              {chapter.cidId.length > 2 ? (
                                <Tooltip
                                  title={chapter.cidId
                                    .slice(1)
                                    .map(cid => cid.name)
                                    .join(", ")}
                                >
                                  <Tag color="#c02222">+{chapter.cidId.length - 1}</Tag>
                                </Tooltip>
                              ) : (
                                // If exactly 2, show the second tag normally
                                chapter.cidId[1] && (
                                  <Tag color="#c02222">{chapter.cidId[1]?.name}</Tag>
                                )
                              )}
                            </>
                          ) : (
                            "N/A"
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ padding: "8px 0" }}>
                          <strong>Location:</strong>
                        </td>
                        <td style={{ padding: "8px 0" }}>
                          {chapter.meetingVenue}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="d-flex align-items-center justify-content-between pt-3">
                    <span className="start-date text-secondary-light">
                      Status:{" "}
                      <span
                        className={
                          chapter.isActive == 1
                            ? "text-success-600"
                            : "text-danger-600"
                        }
                      >
                        {chapter.isActive == 1 ? "Active" : "Inactive"}
                      </span>
                    </span>

                    <div className="d-flex align-items-center gap-2">
                      {hasPermission("chapters-list") && (
                        <button
                          type="button"
                          className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <Link
                            to={`/chapter-view/${chapter._id}`}
                            className="text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                          >
                            <Icon
                              icon="majesticons:eye"
                              className="icon text-xl"
                            />
                          </Link>
                        </button>
                      )}

                      {hasPermission("chapters-update") && (
                        <button
                          type="button"
                          className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModalOne"
                          onClick={() => setSelectedChapter(chapter)}
                        >
                          <Icon icon="lucide:edit" className="menu-icon" />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Add Zone Modal */}
      <div
        className="modal fade"
        id="exampleModalTwo"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-m modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Add New Zone
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeZoneModal"
              />
            </div>
            <div className="modal-body p-24">
              <form onSubmit={handleZoneSubmit}>
                <div className="row">
                  {/* Zone Name */}
                  <div className="col-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Zone Name
                    </label>
                    <CreatableSelect
                      classNamePrefix={`react-select ${errors.zoneName ? "is-invalid" : ""
                        }`}
                      options={options}
                      value={selectedOption}
                      onChange={(value) => {
                        handleChange(value);
                        if (errors.zoneName) {
                          setErrors((prev) => ({ ...prev, zoneName: "" }));
                        }
                      }}
                      onCreateOption={(inputValue) => {
                        if (/^[A-Za-z\s]+$/.test(inputValue)) {
                          handleCreate(inputValue);
                          if (errors.zoneName) {
                            setErrors((prev) => ({ ...prev, zoneName: "" }));
                          }
                        } else {
                          // setErrors(prev => ({ ...prev, zoneName: 'Only alphabets and spaces allowed' }));
                        }
                      }}
                      placeholder="Select or create Zone"
                    />
                    {errors.zoneName && (
                      <div className="text-danger mt-1">{errors.zoneName}</div>
                    )}
                  </div>

                  {/* Country */}
                  <div className="col-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Country
                    </label>
                    <select
                      className={`form-control form-select ${errors.countryName ? "is-invalid" : ""
                        }`}
                      value={zoneFormData.countryName}
                      onChange={(e) => {
                        handleZoneCountryChange(e);
                        if (errors.countryName) {
                          setErrors((prev) => ({ ...prev, countryName: "" }));
                        }
                      }}
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country.value} value={country.value}>
                          {country.label}
                        </option>
                      ))}
                    </select>
                    {errors.countryName && (
                      <div className="text-danger mt-1">
                        {errors.countryName}
                      </div>
                    )}
                  </div>

                  {/* State */}
                  <div className="col-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      State
                    </label>
                    <select
                      className={`form-control form-select ${errors.stateName ? "is-invalid" : ""
                        }`}
                      value={zoneFormData.stateName}
                      onChange={(e) => {
                        handleZoneStateChange(e);
                        if (errors.stateName) {
                          setErrors((prev) => ({ ...prev, stateName: "" }));
                        }
                      }}
                      disabled={!zoneFormData.countryName}
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state.value} value={state.value}>
                          {state.label}
                        </option>
                      ))}
                    </select>
                    {errors.stateName && (
                      <div className="text-danger mt-1">{errors.stateName}</div>
                    )}
                  </div>

                  {/* Date of Birth */}
                  <div className="col-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      className={`form-control ${errors.dob ? "is-invalid" : ""
                        }`}
                      name="dob"
                      value={zoneFormData.dob}
                      onChange={(e) => {
                        handleZoneInputChange(e);
                        if (errors.dob) {
                          setErrors((prev) => ({ ...prev, dob: "" }));
                        }
                      }}
                    />
                    {errors.dob && (
                      <div className="text-danger mt-1">{errors.dob}</div>
                    )}
                  </div>

                  <div className="d-flex align-items-center gap-3 mt-24">
                    <button
                      type="reset"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary grip border border-primary-600 text-md px-48 py-12 radius-8"
                      disabled={Object.keys(errors).some((key) => errors[key])}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Add Chapter Modal */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Add New Chapter
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeChapterModal"
              />
            </div>
            <div className="modal-body p-24">
              <form onSubmit={handleChapterSubmit}>
                <div className="row">
                  {/* Chapter Name */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Chapter Name
                    </label>
                    <input
                      type="text"
                      className={`form-control radius-8 ${chaptererror.chapterName ? "is-invalid" : ""}`}
                      name="chapterName"
                      value={chapterFormData.chapterName}
                      onChange={handleChapterInputChange}
                    />
                    {chaptererror.chapterName && (
                      <div className="text-danger mt-1">{chaptererror.chapterName}</div>
                    )}
                  </div>

                  {/* Country */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Country
                    </label>
                    <select
                      className={`form-control form-select ${chaptererror.countryName ? "is-invalid" : ""}`}
                      name="countryName"
                      value={chapterFormData.countryName}
                      onChange={handleChapterCountryChange}
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country.value} value={country.value}>
                          {country.label}
                        </option>
                      ))}
                    </select>
                    {chaptererror.countryName && (
                      <div className="text-danger mt-1">{chaptererror.countryName}</div>
                    )}
                  </div>

                  {/* State */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      State
                    </label>
                    <select
                      className={`form-control form-select ${chaptererror.stateName ? "is-invalid" : ""}`}
                      name="stateName"
                      value={chapterFormData.stateName}
                      onChange={handleChapterStateChange}
                      disabled={!chapterFormData.countryName}
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state.value} value={state.value}>
                          {state.label}
                        </option>
                      ))}
                    </select>
                    {chaptererror.stateName && (
                      <div className="text-danger mt-1">{chaptererror.stateName}</div>
                    )}
                  </div>

                  {/* Zone */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Zone
                    </label>
                    <select
                      className={`form-control form-select ${chaptererror.zoneId ? "is-invalid" : ""}`}
                      name="zoneId"
                      value={chapterFormData.zoneId}
                      onChange={handleChapterZoneChange}
                      disabled={!chapterFormData.stateName}
                    >
                      <option value="">Select Zone</option>
                      {zones.map((zone) => (
                        <option key={zone.value} value={zone.value}>
                          {zone.label}
                        </option>
                      ))}
                    </select>
                    {chaptererror.zoneId && (
                      <div className="text-danger mt-1">{chaptererror.zoneId}</div>
                    )}
                  </div>

                  {/* Chapter Mentors */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Chapter Mentors
                    </label>
                    <Select
                      className={`react-select-container ${chaptererror.mentorId ? "is-invalid" : ""}`}
                      classNamePrefix="react-select"
                      options={mentors}
                      value={mentors.find((mentor) => mentor.value === chapterFormData.mentorId)}
                      onChange={(selectedOption) => {
                        const selectedValue = selectedOption ? selectedOption.value : "";
                        setChapterFormData((prev) => ({
                          ...prev,
                          mentorId: selectedValue,
                        }));
                        if (chaptererror.mentorId) {
                          setChapterError((prev) => ({ ...prev, mentorId: "" }));
                        }
                      }}
                      placeholder="Select Mentor"
                    />
                    {chaptererror.mentorId && (
                      <div className="text-danger mt-1">{chaptererror.mentorId}</div>
                    )}
                  </div>
                  {/* CIDs */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Chapter Induction Directors
                    </label>
                    <Select
                      isMulti
                      className={`react-select-container ${chaptererror.cidId ? "is-invalid" : ""}`}
                      classNamePrefix="react-select"
                      options={cids}
                      value={cids.filter((cid) =>
                        chapterFormData.cidId.includes(cid.value)
                      )}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions
                          ? selectedOptions.map((option) => option.value)
                          : [];
                        setChapterFormData((prev) => ({
                          ...prev,
                          cidId: selectedValues,
                        }));
                        if (chaptererror.cidId) {
                          setChapterError((prev) => ({ ...prev, cidId: "" }));
                        }
                      }}
                      placeholder="Select CIDs"
                    />
                    {chaptererror.cidId && (
                      <div className="text-danger mt-1">{chaptererror.cidId}</div>
                    )}
                  </div>
                  {/* Chapter Created Date */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Chapter Created Date
                    </label>
                    <input
                      type="date"
                      className={`form-control ${chaptererror.chapterCreatedDate ? "is-invalid" : ""}`}
                      name="chapterCreatedDate"
                      value={chapterFormData.chapterCreatedDate}
                      onChange={handleChapterInputChange}
                    />
                    {chaptererror.chapterCreatedDate && (
                      <div className="text-danger mt-1">{chaptererror.chapterCreatedDate}</div>
                    )}
                  </div>

                  {/* Meeting Day & Time */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Meeting Day & Time
                    </label>
                    <input
                      type="datetime-local"
                      className={`form-control ${chaptererror.meetingDayAndTime ? "is-invalid" : ""}`}
                      name="meetingDayAndTime"
                      value={chapterFormData.meetingDayAndTime}
                      onChange={handleChapterInputChange}
                    />
                    {chaptererror.meetingDayAndTime && (
                      <div className="text-danger mt-1">{chaptererror.meetingDayAndTime}</div>
                    )}
                  </div>

                  {/* Location */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Location
                    </label>
                    <input
                      type="text"
                      className={`form-control radius-8 ${chaptererror.meetingVenue ? "is-invalid" : ""}`}
                      name="meetingVenue"
                      value={chapterFormData.meetingVenue}
                      onChange={handleChapterInputChange}
                    />
                    {chaptererror.meetingVenue && (
                      <div className="text-danger mt-1">{chaptererror.meetingVenue}</div>
                    )}
                  </div>

                  {/* Meeting Type */}
                  <div className="col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Meeting Type
                    </label>
                    <select
                      className={`form-control form-select ${chaptererror.meetingType ? "is-invalid" : ""}`}
                      name="meetingType"
                      value={chapterFormData.meetingType}
                      onChange={handleChapterInputChange}
                    >
                      <option value="Online">Online</option>
                      <option value="In Person">In Person</option>
                      <option value="Hybrid">Hybrid</option>
                    </select>
                    {chaptererror.meetingType && (
                      <div className="text-danger mt-1">{chaptererror.meetingType}</div>
                    )}
                  </div>
                </div>

                {/* Action Buttons - Full Width */}
                <div className="d-flex align-items-center gap-3 mt-24">
                  <button
                    type="reset"
                    className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary grip border border-primary-600 text-md px-48 py-12 radius-8"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


      {/* Edit Chapter Modal */}
      {/* Edit Chapter Modal */}
      <div
        className="modal fade"
        id="exampleModalOne"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-m modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Edit Chapter Status
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeEditModal"
              />
            </div>
            <div className="modal-body p-24">
              {selectedChapter && (
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    try {
                      const response =
                        await chapterApiProvider.updateChapterStatus(
                          selectedChapter._id,
                          { isActive: selectedChapter.isActive }
                        );
                      if (response && response.status) {
                        Swal.fire({
                          title: "Success!",
                          text: "Chapter status updated successfully",
                          icon: "success",
                          customClass: {
                            popup: "small-swal-popup",
                            title: "small-swal-title",
                            htmlContainer: "small-swal-text",
                          },
                          width: "400px",
                        });
                        document.getElementById("closeEditModal").click();
                        fetchChapters();
                      }
                    } catch (error) {
                      Swal.fire({
                        title: "Error!",
                        text:
                          error.message || "Failed to update chapter status",
                        icon: "error",
                        customClass: {
                          popup: "small-swal-popup",
                          title: "small-swal-title",
                          htmlContainer: "small-swal-text",
                        },
                        width: "400px",
                      });
                    }
                  }}
                >
                  <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <tbody>
                      <tr
                        style={{
                          borderBottom: "1px solid #eee",
                          padding: "8px 0",
                        }}
                      >
                        <td style={{ padding: "8px 0" }}>
                          <strong>Chapter Name:</strong>
                        </td>
                        <td style={{ padding: "8px 0" }}>
                          {selectedChapter.chapterName}{" "}
                          <span className="chapterday">
                            ({formatDayName(selectedChapter.meetingDayAndTime)})
                          </span>
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderBottom: "1px solid #eee",
                          padding: "8px 0",
                        }}
                      >
                        <td style={{ padding: "8px 0" }}>
                          <strong>Zone:</strong>
                        </td>
                        <td style={{ padding: "8px 0" }}>
                          {selectedChapter.zoneId?.zoneName || "N/A"}
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderBottom: "1px solid #eee",
                          padding: "8px 0",
                        }}
                      >
                        <td style={{ padding: "8px 0" }}>
                          <strong>CID:</strong>
                        </td>
                        <td style={{ padding: "8px 0" }}>
                          {selectedChapter.cidId?.name || "N/A"}
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderBottom: "1px solid #eee",
                          padding: "8px 0",
                        }}
                      >
                        <td style={{ padding: "8px 0" }}>
                          <strong>Location:</strong>
                        </td>
                        <td style={{ padding: "8px 0" }}>
                          {selectedChapter.meetingVenue}
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderBottom: "1px solid #eee",
                          padding: "8px 0",
                        }}
                      >
                        <td style={{ padding: "8px 0" }}>
                          <strong>Status:</strong>
                        </td>
                        <td style={{ padding: "8px 0" }}>
                          <select
                            className="form-control form-select"
                            value={selectedChapter.isActive}
                            onChange={(e) =>
                              setSelectedChapter({
                                ...selectedChapter,
                                isActive: parseInt(e.target.value),
                              })
                            }
                            style={{
                              width: "150px",
                              padding: "8px 8px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              backgroundColor: "#fff",
                            }}
                          >
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="d-flex align-items-center gap-3 mt-24 justify-content-end">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary grip border border-primary-600 text-md px-48 py-12 radius-8"
                    >
                      Update Status
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChapterAccessLayer;
